import { useState, useEffect } from "react";
import axios from "axios";

export const useLocales = () => {
  const [locales, setLocales] = useState({});
  const [isFetchingLocales, setFetchingLocales] = useState(true);
  const [localesError, setLocalesError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios({
          url: `/locales/en.json`,
        });

        setLocales(response.data);
      } catch (error) {
        setLocalesError(error);
      } finally {
        setFetchingLocales(false);
      }
    };

    fetchData();
  }, []);

  return { locales, isFetchingLocales, localesError };
};
